import { useFormikContext } from 'formik'
import type { BusyButtonProps, SaveCancelButtonsProps } from '@ztechapps/webui.button'
import { BusyButton } from '@ztechapps/webui.button'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import React from 'react'

export const FormSaveCancelButtons = (props: SaveCancelButtonsProps) => {
  const { handleSubmit, handleReset, isSubmitting, isValid, dirty } = useFormikContext()

  return (
    <SaveCancelButtons
      disabled={dirty && !isValid}
      isBusy={isSubmitting}
      onCancel={handleReset}
      onSave={handleSubmit}
      {...props}
    />
  )
}

export const FormSaveButton = (props: BusyButtonProps) => {
  const { handleSubmit, isSubmitting, isValid, dirty } = useFormikContext()

  return (
    <BusyButton
      type="submit"
      variant={'primary'}
      disabled={dirty && !isValid}
      isBusy={isSubmitting}
      onClick={handleSubmit}
      icon="save"
      text="Save"
      {...props}
    />
  )
}
